module.exports = __webpack_public_path__ + "img/rcsvg.74b9b8d9.svg";